<template>
	<div>
		<Modal 
		:loading="loading" 
		:title="'PERMISSÕES DO USUÁRIO'"
		@close="close"
		@save="save">
			<div class="row">
				<div class="col-xs-12">
					<h4>Seções</h4>
				</div>
				<div v-for="(item, index) in list_order" :key="index" class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
					<div class="form-input-group">
						<FormCheckbox v-model="permissions[item].active" :label="getLabel(item)" :icon="getIcon(item)" :tooltip="'Selecione para definir a permissão de acesso a seção de ' + getLabel(item)" @input="checkArea(item)" />
						<div class="row form-input-group-checkbox">
							<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
								<label class="input-label" :class="!permissions[item].active ? 'input-label-disabled' : ''" @click="!permissions[item].permissions.read">
									<input v-model="permissions[item].permissions.read" type="checkbox" :disabled="!permissions[item].active" @change="checkAreaReadPermission(item)" /> Leitura
								</label>
								<label class="input-label" :class="!permissions[item].active ? 'input-label-disabled' : ''" @click="!permissions[item].permissions.edit">
									<input v-model="permissions[item].permissions.edit" type="checkbox" :disabled="!permissions[item].active" @change="checkAreaEditPermission(item)"  /> Alteração
								</label>
								<label class="input-label" :class="!permissions[item].active ? 'input-label-disabled' : ''" @click="!permissions[item].permissions.admin">
									<input v-model="permissions[item].permissions.admin" type="checkbox" :disabled="!permissions[item].active" @change="checkAreaAdminPermission(item)" /> Administrador
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormCheckbox from "@/components/FormCheckbox";

export default {
	name: "ConfigUsersPermissions",

	props: {
		current: {
			type: Object,
			require: true,
		}
	},

	components: {
		Modal,
		FormCheckbox
	},

	data: function() {
		return {
			loading: false,
			list_order: [
				"Customer",
				"DistributionCenter",
				"Driver",
				"Vehicle",
				"Delivery",
				"DeliveryRouting",
				"Tracking",
				"Report",
				"Config",
				"User",
			],
			permissions: JSON.parse(this.current.permissions)
		};
	},

	methods: {
		hasPermission: function(route) {
			if (this.$api.user.is_admin)
				return true;
			if (this.permissions[route].active)
				return true;
			return false;
		},

		getIcon(area) {
			let icon = "";
			switch (area) {
				case "Config":
					icon = "fa-cog";
					break;
				case "Customer":
					icon = "fa-building";
					break;
				case "Delivery":
					icon = "fa-boxes";
					break;
				case "DeliveryRouting": 
					icon = "fa-route";
					break;
				case "DistributionCenter": 
					icon = "fa-pallet";
					break;
				case "Driver": 
					icon = "fa-address-card";
					break;
				case "Report": 
					icon = "fa-file-invoice";
					break;
				case "Tracking":
					icon = "fa-map-marked-alt";
					break;
				case "Vehicle": 
					icon = "fa-truck";
					break;
				case "User": 
					icon = "fa-users";
					break;

				default:
					break;
			}
			return icon;
		},

		getLabel(area) {
			let label = "Área";
			switch (area) {
				case "Config":
					label = "Configurações";
					break;
				case "Customer":
					label = "Clientes";
					break;
				case "Delivery":
					label = "Entregas";
					break;
				case "DeliveryRouting": 
					label = "Roteirizações";
					break;
				case "DistributionCenter": 
					label = "Centros Distribuição";
					break;
				case "Driver": 
					label = "Motoristas";
					break;
				case "Report": 
					label = "Relatório";
					break;
				case "Tracking":
					label = "Rastreio";
					break;
				case "Vehicle": 
					label = "Veículos";
					break;
				case "User": 
					label = "Usuários";
					break;
					
				default:
					break;
			}
			return label;
		},

		save: async function() {
			let form = {
				id: this.current.id,
				permissions: JSON.stringify(this.permissions)
			};
			
			this.loading = true;
			let result = null;
			try {
				result = await Api.post("user/save-user-permissions", form);
			} catch(ex) {
				console.log(ex);
				this.$notifications.error("Não foi possível salvar as permissões.");
				return;
			}
			this.loading = false;

			if (result != null) {
				if (result.error) {
					this.$notifications.error(result.data);
					return;
				} else {
					await this.$alert.alert("Essas alterações entrarão em efeito após o próximo login do usuário.");
					this.$notification.success("Permissões salvas com sucesso.");
					this.$parent.load();
					this.close();
					return;
				}
			} else {
				this.$notifications.error("Não foi possível salvar as permissões.");
				return;
			}
		},

		close: function() {
			this.$emit("close");
		},

		checkPermissionsConfig: function(event) {
			if (!event) {
				this.permissions.Invoice = 0;
				this.permissions.User = 0;
			}
		},

		checkArea: function(area) {
			if (this.permissions[area].active) {
				this.permissions[area].permissions.read = true;
				this.permissions[area].permissions.edit = false;
				this.permissions[area].permissions.admin = false;
				if (area == "User") {
					this.permissions["Config"].active = true;
					this.permissions["Config"].permissions.read = true;
				}
			} else {
				this.permissions[area].permissions.read = false;
				this.permissions[area].permissions.edit = false;
				this.permissions[area].permissions.admin = false;
				if (area == "Config") {
					this.permissions["User"].active = false;
					this.permissions["User"].permissions.read = false;
					this.permissions["User"].permissions.edit = false;
					this.permissions["User"].permissions.admin = false;
				}
			}
		},

		checkAreaReadPermission: function(area) {
			if (this.permissions[area].permissions.read) {
				if (this.permissions[area].permissions.edit)
					this.permissions[area].permissions.admin = true;
			} else {
				this.permissions[area].active = false;
				this.permissions[area].permissions.edit = false;
				this.permissions[area].permissions.admin = false;
			}
		},
		
		checkAreaEditPermission: function(area) {
			if (this.permissions[area].permissions.edit) {
				if (this.permissions[area].permissions.read)
					this.permissions[area].permissions.admin = true;
			} else 
				this.permissions[area].permissions.admin = false;
		},

		checkAreaAdminPermission: function(area) {
			if (this.permissions[area].permissions.admin) {
				this.permissions[area].permissions.read = true;
				this.permissions[area].permissions.edit = true;
			} else
				this.permissions[area].permissions.edit = false;
		},
	}
}
</script>

<style scoped>
	.input-label {
		cursor: pointer;
		margin-right: 10px;
	}
	.form-input-group {
		margin-bottom: 1rem;
		padding: .5rem .5rem 0 .5rem;
		border: 1px solid #eaeaea;
		border-radius: 4px;
	}
	.form-input-group-checkbox {
		background-color: #eaeaea;
		padding: .5rem;
	}
	input[type="checkbox"] {
		accent-color: #555;
	}

	.input-label-disabled {
		color: #c2c2c9;
	}
</style>